module.exports = __webpack_public_path__ + "img/checked.5f6cd4e.svg";